import { cn } from '@/utils/cn';

interface Props {
  isOpen: boolean;
  handleCloseSideBar: () => void;
}

export default function SidebarOverlay({ isOpen, handleCloseSideBar }: Props) {
  return (
    <button
      type="button"
      className={cn(
        'fixed top-0 left-0 bg-black/60 w-full h-dvh mt-16 lg:h-screen lg:hidden max-lg:z-10',
        'transition-opacity duration-300 ease-in-out',
        {
          'opacity-100 pointer-events-auto': isOpen,
          'opacity-0 pointer-events-none': !isOpen,
        },
      )}
      onClick={handleCloseSideBar}
    />
  );
}
